<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div>
    <div class="productContainer_m">
      <div
        class="partOne partSpacial"
        style="padding-bottom: 0.36rem; background: #f9f7f5"
      >
        <div class="top">
          <div class="title">Customized Supplements</div>
          <div class="subTitle">个性化定制营养</div>

          <div class="des">
            + 5大核心营养 29款膳食补剂<br />
            + 瞄准15种健康问题<br />
            + 精准补充 满足千人千面需求
          </div>
        </div>
        <div class="makeBtn cursor" @click="toMake($event, 1)">
          Have a Try
          <!-- <img :src="arrUrl1" class="arrR" /> -->
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/productSeries/arr_r_w.png"
            class="arrR"
          />
        </div>
        <img
          src="https://cdn-file.xiaojudai.cn/web/dist/productSeries/productSeries_pic1_1920.png"
          class="big_img"
        />
      </div>
      <div class="partOne" style="padding-bottom: 0.75rem; background: #fdfdfd">
        <div class="top">
          <div class="title">Stansard Monthly Kit</div>
          <div class="subTitle">30天功能营养包</div>

          <div class="des">
            + 专注解决特定健康问题<br />
            + 30天深层调理<br />
            + 持久改善 养出健康体质
          </div>
        </div>
        <div class="makeBtn makeBtn2 cursor" @click="toMake($event, 2)">
          Have a Try
          <img :src="arrUrl2" class="arrR" />
        </div>
        <img
          src="https://cdn-file.xiaojudai.cn/web/dist/productSeries/pic2_m.png"
          class="big_img"
          style="width: 142%; transform: translateX(-28%)"
        />
      </div>

      <div class="partOne" style="padding-bottom: 0.36rem; background: #fbfbf8">
        <div class="top">
          <div class="title">5-Day Care Packs</div>
          <div class="subTitle">5天应急产品线</div>

          <div class="des">
            + 7大常见健康场景<br />
            + 5天快速起效<br />
            + 轻松解决生活中常见的健康小问题
          </div>
        </div>
        <div class="makeBtn makeBtn2 cursor" @click="toMake($event, 3)">
          Have a Try
          <img :src="arrUrl2" class="arrR" />
        </div>
        <!-- 占位 -->
         <!-- <div style="height: .3rem;"></div> -->
        <img
          src="https://cdn-file.xiaojudai.cn/web/dist/productSeries/pic3_m.png"
          class="big_img"
          style="width: 150%; margin-top: 0.24rem; padding-bottom: 0.87rem"
        />
      </div>

      <div class="partOne" style="padding-bottom: 0.36rem; background: #f2f3f4">
        <div class="top">
          <div class="title">N-acetylneuraminic Acid <br />Drink</div>
          <div class="subTitle">维他同学燕窝酸饮</div>

          <div class="des">
            + DHA+燕窝酸 黄金脑营养<br />
            + 4大核心成分 32+国家专利<br />
            + 干净原料 全链溯源
          </div>
        </div>
        <div class="makeBtn makeBtn2 cursor" @click="toMake($event, 4)">
          Have a Try
          <img :src="arrUrl2" class="arrR" />
        </div>
        <img
          src="https://cdn-file.xiaojudai.cn/web/dist/productSeries/pic4_m.png"
          class="big_img"
          style="width: 150%; transform: translateX(-28%)"
        />
      </div>
    </div>

    <!-- 1140 -->
    <div class="productContainer_1140">
      <div class="partOne" style="background-color: #f9f7f5">
        <div class="actionBox">
          <div class="contentBox">
            <div class="mainTitle">Customized Supplements</div>
            <div class="subTitle">个性化定制营养</div>
            <div class="des">
              + 5大核心营养 29款膳食补剂<br />
              + 瞄准15种健康问题<br />
              + 精准补充 满足千人千面需求
            </div>
            <div class="makeBtn cursor" @click="toMake($event, 1)">
              Have a Try
              <img
                src="https://cdn-file.xiaojudai.cn/web/dist/quality/arr_r_w.png"
                class="arrR"
              />
            </div>
          </div>
        </div>
        <img
          src="https://cdn-file.xiaojudai.cn/web/dist/productSeries/pro_pic1_1440.png"
          class="big_img"
        />
      </div>
      <div class="partOne" style="background-color: #fdfdfd">
        <img
          src="https://cdn-file.xiaojudai.cn/web/dist/productSeries/pro_pic2_1440.png"
          class="big_img big_img2"
        />
        <div class="actionBox">
          <div class="contentBox contentBox2">
            <div class="mainTitle">Stansard Monthly Kit</div>
            <div class="subTitle">30天功能营养包</div>
            <div class="des">
              + 专注解决特定健康问题<br />
              + 30天深层调理<br />
              + 持久改善 养出健康体质
            </div>
            <div
              class="makeBtn makeBtn2 cursor"
              @mouseenter="changeUrl1(0)"
              @mouseleave="changeUrl1(1)"
              @click="toMake($event, 2)"
            >
              Have a Try
              <img :src="arrUrl1" class="arrR" />
            </div>
          </div>
        </div>
      </div>
      <div class="partOne" style="background-color: #fbfbf8">
        <div class="actionBox">
          <div class="contentBox" style="margin-left: 0px">
            <div class="mainTitle">5-Day Care Packs</div>
            <div class="subTitle">5天应急产品线</div>
            <div class="des">
              + 7大常见健康场景<br />
              + 5天快速起效<br />
              + 轻松解决生活中常见的健康小问题
            </div>
            <div
              class="makeBtn makeBtn2 cursor"
              @mouseenter="changeUrl2(0)"
              @mouseleave="changeUrl2(1)"
              @click="toMake($event, 3)"
            >
              Have a Try
              <img :src="arrUrl2" class="arrR" />
            </div>
          </div>
        </div>
        <img
          src="https://cdn-file.xiaojudai.cn/web/dist/productSeries/pro_pic3_1440.png"
          class="big_img"
        />
      </div>
      <div class="partOne" style="background-color: #f2f3f4">
        <img
          src="https://cdn-file.xiaojudai.cn/web/dist/productSeries/pro_pic4_1440.png"
          class="big_img big_img2"
        />
        <div class="actionBox">
          <div class="contentBox contentBox2">
            <div class="mainTitle">
              N-acetylneuraminic<br />
              Acid Drink
            </div>
            <div class="subTitle">维他同学燕窝酸饮</div>
            <div class="des">
              + DHA+燕窝酸 黄金脑营养<br />
              + 4大核心成分 32+国家专利<br />
              + 干净原料 全链溯源
            </div>
            <div
              class="makeBtn makeBtn2 cursor"
              @mouseenter="changeUrl3(0)"
              @mouseleave="changeUrl3(1)"
              @click="toMake($event, 4)"
            >
              Have a Try
              <img :src="arrUrl3" class="arrR" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 1920 -->
    <div class="productContainer_1920">
      <div class="partOne" style="background-color: #f9f7f5">
        <div class="actionBox">
          <div class="contentBox">
            <div class="mainTitle">Customized Supplements</div>
            <div class="subTitle">个性化定制营养</div>
            <div class="des">
              + 5大核心营养 29款膳食补剂<br />
              + 瞄准15种健康问题<br />
              + 精准补充 满足千人千面需求
            </div>
            <div class="makeBtn cursor" @click="toMake($event, 1)">
              Have a Try
              <img
                src="https://cdn-file.xiaojudai.cn/web/dist/quality/arr_r_w.png"
                class="arrR"
              />
            </div>
          </div>
        </div>
        <img
          src="https://cdn-file.xiaojudai.cn/web/dist/productSeries/productSeries_pic1_1920.png"
          class="big_img"
        />
      </div>
      <div class="partOne" style="background-color: #fbfbfb">
        <img
          src="https://cdn-file.xiaojudai.cn/web/dist/productSeries/pic2.png"
          class="big_img"
        />
        <div class="actionBox">
          <div class="contentBox contentBox2">
            <div class="mainTitle">Stansard Monthly Kit</div>
            <div class="subTitle">30天功能营养包</div>
            <div class="des">
              + 专注解决特定健康问题<br />
              + 30天深层调理<br />
              + 持久改善 养出健康体质
            </div>
            <div
              class="makeBtn makeBtn2 cursor"
              @mouseenter="changeUrl1(0)"
              @mouseleave="changeUrl1(1)"
              @click="toMake($event, 2)"
            >
              Have a Try
              <img :src="arrUrl1" class="arrR" />
            </div>
          </div>
        </div>
      </div>
      <div class="partOne" style="background-color: #fbfbf8">
        <div class="actionBox">
          <div class="contentBox" style="margin-left: 0px">
            <div class="mainTitle">5-Day Care Packs</div>
            <div class="subTitle">5天应急产品线</div>
            <div class="des">
              + 7大常见健康场景<br />
              + 5天快速起效<br />
              + 轻松解决生活中常见的健康小问题
            </div>
            <div
              class="makeBtn makeBtn2 cursor"
              @mouseenter="changeUrl2(0)"
              @mouseleave="changeUrl2(1)"
              @click="toMake($event, 3)"
            >
              Have a Try
              <img :src="arrUrl2" class="arrR" />
            </div>
          </div>
        </div>
        <img
          src="https://cdn-file.xiaojudai.cn/web/dist/productSeries/pic3.png"
          class="big_img"
        />
      </div>
      <div class="partOne" style="background-color: #f2f3f4">
        <img
          src="https://cdn-file.xiaojudai.cn/web/dist/productSeries/pic4.png"
          class="big_img"
        />
        <div class="actionBox">
          <div class="contentBox contentBox2">
            <div class="mainTitle">
              N-acetylneuraminic<br />
              Acid Drink
            </div>
            <div class="subTitle">维他同学燕窝酸饮</div>
            <div class="des">
              + DHA+燕窝酸 黄金脑营养<br />
              + 4大核心成分 32+国家专利<br />
              + 干净原料 全链溯源
            </div>
            <div
              class="makeBtn makeBtn2 cursor"
              @mouseenter="changeUrl3(0)"
              @mouseleave="changeUrl3(1)"
              @click="toMake($event, 4)"
            >
              Have a Try
              <img :src="arrUrl3" class="arrR" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 定制弹窗 -->
    <CodePupop
      ref="myPupop"
      :position="position"
      :left="left"
      :top="top"
    ></CodePupop>
  </div>
</template>

<script>
import CodePupop from "../components/codePupop.vue";

export default {
  name: "productSeries",
  components: { CodePupop },
  data: () => ({
    arrUrl1: "https://cdn-file.xiaojudai.cn/web/dist/productSeries/arr_r_b.png",
    arrUrl2: "https://cdn-file.xiaojudai.cn/web/dist/productSeries/arr_r_b.png",
    arrUrl3: "https://cdn-file.xiaojudai.cn/web/dist/productSeries/arr_r_b.png",
    position: "bottom",
    left: 0,
    top: 0,
  }),
  updated() {
    var th = this.$refs.thisheight;
    if (th.scrollHeight > 500) {
      this.showmore = true;
    }
  },
  mounted() {},
  methods: {
    toMake(event, type) {
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;
      let clickX = event.clientX; // 相对于视口的X坐标
      let clickY = event.clientY; // 相对于视口的Y坐标
      // 判断水平方向
      const horizontal = clickX < screenWidth / 2 ? "左" : "右";
      // 判断垂直方向
      const vertical = clickY < screenHeight / 2 ? "上" : "下";
      console.log(clickX, clickY);
      switch (horizontal + vertical) {
        case "左上":
          clickX = clickX / 54 + 3;
          clickY = clickY / 54 + 1 - 5;
          break;
        case "左下":
          clickX = clickX / 54 + 3;
          clickY = clickY / 54 - 8.5 + 5;
          break;
        case "右上":
          clickX = clickX / 54 - 10;
          clickY = clickY / 54 + 1.5 - 5;
          break;
        case "右下":
          clickX = clickX / 54 - 10;
          clickY = clickY / 54 - 9 + 5;
          break;
      }
      this.left = clickX;
      this.top = clickY;

      this.$refs.myPupop.showPupop(type);
    },
    changeUrl1(e) {
      this.arrUrl1 =
        e === 0
          ? "https://cdn-file.xiaojudai.cn/web/dist/quality/arr_r_w.png"
          : "https://cdn-file.xiaojudai.cn/web/dist/productSeries/arr_r_b.png";
    },
    changeUrl2(e) {
      this.arrUrl2 =
        e === 0
          ? "https://cdn-file.xiaojudai.cn/web/dist/productSeries/arr_r_w.png"
          : "https://cdn-file.xiaojudai.cn/web/dist/productSeries/arr_r_b.png";
    },
    changeUrl3(e) {
      this.arrUrl3 =
        e === 0
          ? "https://cdn-file.xiaojudai.cn/web/dist/productSeries/arr_r_w.png"
          : "https://cdn-file.xiaojudai.cn/web/dist/productSeries/arr_r_b.png";
    },
  },
};
</script>

<style lang="scss" scoped>
.cursor {
  cursor: pointer;
}
//mobile414
@media screen and (max-width: 767px) {
   .productContainer_1140 {
    display: none;
  }
  .productContainer_1920 {
    display: none;
  }
  .productContainer_m {
    margin-top: 1.38rem;
    position: relative;
    overflow-x: hidden;
    .partOne {
      padding-top: 1.47rem;
      .top {
        padding-left: 0.58rem;
        .title {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.72rem;
          color: #141414;
          line-height: 0.85rem;
          text-align: left;
          font-style: normal;
        }
        .subTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.31rem;
          color: #000000;
          line-height: 0.43rem;
          text-align: left;
          font-style: normal;
          margin-top: 0.24rem;
        }
        .des {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.29rem;
          color: #141414;
          line-height: 0.63rem;
          text-align: left;
          font-style: normal;
          margin-top: 0.77rem;
        }
      }
      .makeBtn {
        width: 3.21rem;
        height: 1.06rem;
        background: #c25e4d;
        border-radius: 0.97rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 0.58rem;
        margin-top: 0.77rem;

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 0.31rem;
        color: #ffffff;
        line-height: 0.43rem;
        text-align: left;
        font-style: normal;
        .arrR {
          width: 0.31rem;
          height: 0.24rem;
          margin-left: 0.27rem;
        }
      }
      .makeBtn2 {
        color: #1a1a1a;
        background: none;
        border: 0.01rem solid #000000;
      }
      .big_img {
        width: 150%;
        height: auto;
      }
    }
    .partSpacial {
      .big_img {
        width: 130%;
        height: auto;
      }
    }
  }
}
//pad768
@media screen and (min-width: 768px) and (max-width: 1439px) {
  .productContainer_1140 {
    display: none;
  }
  .productContainer_1920 {
    display: none;
  }
  .productContainer_m {
    margin-top: 1.64rem;
    position: relative;
    overflow-x: hidden;
    .partOne {
      padding-top: 1.48rem;
      .top {
        padding-left: 0.81rem;
        .title {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.81rem;
          color: #1a1a1a;
          line-height: 0.96rem;
          text-align: left;
          font-style: normal;
        }
        .subTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.41rem;
          color: #000000;
          line-height: 0.56rem;
          text-align: left;
          font-style: normal;
          margin-top: 0.15rem;
        }
        .des {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.3rem;
          color: #141414;
          line-height: 0.59rem;
          text-align: left;
          font-style: normal;

          margin-top: 0.46rem;
        }
      }
      .makeBtn {
        width: 3.19rem;
        height: 1.11rem;
        background: #c25e4d;
        border-radius: 0.74rem;

        display: flex;
        align-items: center;
        justify-content: center;

        margin-left: 0.81rem;
        margin-top: 0.74rem;

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 0.3rem;
        color: #ffffff;
        line-height: 0.41rem;
        text-align: center;
        font-style: normal;

        .arrR {
          width: 0.33rem;
          height: 0.24rem;
          margin-left: 0.2rem;
        }
      }
      .makeBtn2 {
        color: #1a1a1a;
        background: none;
        border: 0.01rem solid #000000;
      }
      .big_img {
        width: 150%;
        height: auto;
      }
    }
    .partSpacial {
      .big_img {
        width: 130%;
        height: auto;
      }
    }
  }
}
//小web1440
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .productContainer_m {
    display: none;
  }
  .productContainer_1920 {
    display: none;
  }
  .productContainer_1140 {
    .partOne {
      height: 11.11rem;
      display: flex;
      align-items: center;
      .actionBox {
        width: 45%;
        height: 100%;
        display: flex;
        padding-left: 1.83rem;
        .contentBox {
          padding-right: 0.7rem;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-left: 0rem;
          min-width:8.94rem ;
          .mainTitle {
            font-family: MADEEvolveSans, MADEEvolveSans;
            font-weight: bold;
            font-size: 0.81rem;
            color: #1a1a1a;
            line-height: 0.96rem;
            text-align: left;
            font-style: normal;
          }
          .subTitle {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 0.41rem;
            color: #000000;
            line-height: 0.56rem;
            text-align: left;
            font-style: normal;
            margin-top: 0.15rem;
          }
          .des {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 0.3rem;
            color: #141414;
            line-height: 0.59rem;
            text-align: left;
            font-style: normal;
            margin-top: 0.46rem;
          }
          .makeBtn {
            width: 3.19rem;
            height: 1.11rem;
            background: #c25e4d;
            border-radius: 0.74rem;

            display: flex;
            align-items: center;
            justify-content: center;

            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 0.3rem;
            color: #ffffff;
            line-height: 0.41rem;
            text-align: center;
            font-style: normal;

            margin-top: 0.74rem;

            .arrR {
              margin-left: 0.2rem;
              width: 0.33rem;
              height: 0.24rem;
            }
            // .arrR_btn1_m{
            //   display: none;
            // }
          }
          .makeBtn:hover {
            background-color: #d15c4d;
          }
          .makeBtn2 {
            background-color: white;
            color: #000;
            border: 0.02rem solid #000000;
          }
          .makeBtn2:hover {
            background-color: #d15c4d;
            border: none;
            color: white;
          }
        }
        .contentBox2 {
          padding-left: 0.36rem;
        }
      }
      .big_img {
        margin-right: -17%;
        width: 72%;
        min-width: 15.19rem;
        height: 100%;
      }
       .big_img2 {
        margin-right: 0;
        width: 72%;
        margin-left: -17%;
        min-width: 15.19rem;
        height: 100%;
      }
    }
  }
}
// 1920
@media screen and (min-width: 1920px) {
  .productContainer_m {
    display: none;
  }
  .productContainer_1140 {
    display: none;
  }
  .productContainer_1920 {
    .partOne {
      height: 11.11rem;
      display: flex;
      align-items: center;
      .actionBox {
        width: 45%;
        height: 100%;
        display: flex;
        justify-content: center;
        .contentBox {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-left: 2.2rem;
          .mainTitle {
            font-family: MADEEvolveSans, MADEEvolveSans;
            font-weight: bold;
            font-size: 0.81rem;
            color: #1a1a1a;
            line-height: 0.96rem;
            text-align: left;
            font-style: normal;
          }
          .subTitle {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 0.41rem;
            color: #000000;
            line-height: 0.56rem;
            text-align: left;
            font-style: normal;
            margin-top: 0.15rem;
          }
          .des {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 0.3rem;
            color: #141414;
            line-height: 0.59rem;
            text-align: left;
            font-style: normal;
            margin-top: 0.46rem;
          }
          .makeBtn {
            width: 3.19rem;
            height: 1.11rem;
            background: #c25e4d;
            border-radius: 0.74rem;

            display: flex;
            align-items: center;
            justify-content: center;

            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 0.3rem;
            color: #ffffff;
            line-height: 0.41rem;
            text-align: center;
            font-style: normal;

            margin-top: 0.74rem;

            .arrR {
              margin-left: 0.2rem;
              width: 0.33rem;
              height: 0.24rem;
            }
            // .arrR_btn1_m{
            //   display: none;
            // }
          }
          .makeBtn:hover {
            background-color: #d15c4d;
          }
          .makeBtn2 {
            background-color: white;
            color: #000;
            border: 0.02rem solid #000000;
          }
          .makeBtn2:hover {
            background-color: #d15c4d;
            border: none;
            color: white;
          }
        }
        .contentBox2 {
          margin-right: 2.2rem;
          margin-left: 0;
        }
      }
      .big_img {
        width: 55%;
        min-width: 19.63rem;
        height: 100%;
      }
    }
  }
}
</style>
